// 定义内容
export default {
	login: {
		placeholder1: '请输入用户名',
		placeholder2: '请输入密码',
		placeholder3: '请输入验证码',
		btnText: '登 录',
		link: {
			one1: '第三方登录',
			one2: '友情链接',
		},
		signInText: '欢迎回来！',
		copyright: {
			one5: '版权所有：深圳市豪亚集团',
			two6: 'Copyright: Shenzhen haoya *** Technology 粤ICP备********号',
		},
	},
};
